import Step from './DashboardBuilderStep'
import { useAct } from 'DashboardBuilder/store'
import DashboardFieldEditor from './DashboardFields/DashboardFieldEditor'
import dashboardFields from 'DashboardBuilder/store/dashboardFields'

function ShortDescriptor() {
  const fieldCount = useSel(s => _.values(s.dashboardFields.entities).filter(f => f.active).length)
  const complete = fieldCount > 0

  if (!complete){
    return <p className='incomplete no-margin-bottom'>Add columns to the dashboard</p>
  } else {
    return <p className='complete no-margin-bottom'>{fieldCount} {fieldCount === 1 ? 'column' : 'columns'} added</p>
  }
}

export default function DashboardFields() {
  const act = useAct()
  const fieldCount = useSel(s => _.values(s.dashboardFields.entities).filter(f => f.active).length)
  const invalidFields = useSel(s => dashboardFields.selectInvalidDashboardFields(s))
  const complete = fieldCount > 0

  function save() {
    return act.builder.save('dashboardFields').then(() => {
      act.builder.closeEditor()
    })
  }

  return (
    <Step
      name="Dashboard columns"
      editor="dashboardFields"
      editable={true}
      complete={complete}
      save={save}
      canClickFinish={invalidFields.length === 0}
      shortDescriptor={<ShortDescriptor />}>
      <DashboardFieldEditor />
    </Step>
  )
}
